import { Icon } from './JournalOverview';
import './workspace-bar.css';

const VIEW_LABELS = {
  dashboard: 'Overview', trades: 'Journal', stats: 'Analytics', form: 'Log trade',
  outlooks: 'Plans', reviews: 'Weekly reviews', accounts: 'Accounts', wall: 'The Wall',
  ai: 'AI insights', card: 'Trade cards',
};

export default function WorkspaceBar({ view = 'dashboard', onLock, onAppearance, onSearch, themeName = 'Classic' }) {
  return <header className="tl-workspace-bar tl-workspace-header" aria-label="Workspace controls">
    <div className="tl-workspace-shell">
      <div className="tl-workspace-leading">
        <button type="button" className="tl-icon-button tl-workspace-lock" aria-label="Lock workspace" title="Lock workspace" onClick={onLock}>
          <Icon name="lock" size={17}/>
        </button>
        <nav className="tl-workspace-location" aria-label="Current workspace">
          <ol>
            <li className="tl-workspace-root"><Icon name="grid" size={15}/><span>Workspace</span></li>
            <li aria-current="page"><Icon name="chevron-right" size={13}/><strong>{VIEW_LABELS[view] || 'Workspace'}</strong></li>
          </ol>
        </nav>
      </div>
      <div className="tl-workspace-actions">
        <button type="button" className="tl-appearance-trigger tl-workspace-appearance" data-tour="appearance" aria-label="Workspace appearance" aria-haspopup="dialog" title="Themes and styles" onClick={onAppearance}>
          <Icon name="palette" size={17}/><span>{themeName}</span><Icon name="chevron-right" size={13} className="tl-workspace-chevron"/>
        </button>
        <button type="button" className="tl-search-button tl-workspace-search" aria-label="Jump to anything" aria-keyshortcuts="Meta+K Control+K" title="Jump to anything (⌘ / Ctrl + K)" onClick={onSearch}>
          <Icon name="search" size={17}/><span className="tl-workspace-search-label">Jump to anything</span><kbd aria-hidden="true">⌘ K</kbd>
        </button>
      </div>
    </div>
  </header>;
}
